'use strict';
import {combineReducers} from 'redux';
import {assetTaskReduxItem} from '../redux/assetTaskRouterState';
import {reduxList as assetTasksReduxList} from '../redux/assetTasks';
import {createAssetTaskRequestModal} from '../redux/createAssetTask';
import {createProjectTaskRequestModal} from '../redux/createProjectTask';
import {createTemplateTaskRequestModal} from '../redux/createTemplateTask';
import {projectTaskReduxItem} from '../redux/projectTaskRouterState';
import {reduxList as projectTasksReduxList} from '../redux/projectTasks';
import {
  ASSET_ITEM_NAME,
  ASSET_LIST_NAME,
  CREATE_ASSET_TASK_NAME,
  CREATE_PROJECT_TASK_NAME,
  CREATE_TEMPLATE_TASK_NAME,
  PROJECT_ITEM_NAME,
  PROJECT_LIST_NAME,
  TEMPLATE_ITEM_NAME,
  TEMPLATE_LIST_NAME,
  UPDATE_ASSET_TASK_NAME,
  UPDATE_PROJECT_TASK_NAME,
  UPDATE_TEMPLATE_TASK_NAME,
} from '../redux/state';
import {templateTaskReduxItem} from '../redux/templateTaskRouterState';
import {reduxList as templateTasksReduxList} from '../redux/templateTasks';
import {updateAssetTaskRequestModal} from '../redux/updateAssetTask';
import {updateProjectTaskRequestModal} from '../redux/updateProjectTask';
import {updateTemplateTaskRequestModal} from '../redux/updateTemplateTask';


export * from './state';

export const tasks = combineReducers({
  [ASSET_ITEM_NAME]: assetTaskReduxItem.reducers.reducer,
  [ASSET_LIST_NAME]: assetTasksReduxList.reducers.reducer,
  [PROJECT_ITEM_NAME]: projectTaskReduxItem.reducers.reducer,
  [PROJECT_LIST_NAME]: projectTasksReduxList.reducers.reducer,
  [TEMPLATE_ITEM_NAME]: templateTaskReduxItem.reducers.reducer,
  [TEMPLATE_LIST_NAME]: templateTasksReduxList.reducers.reducer,
  [CREATE_ASSET_TASK_NAME]: createAssetTaskRequestModal.reducers.reducer,
  [CREATE_PROJECT_TASK_NAME]: createProjectTaskRequestModal.reducers.reducer,
  [CREATE_TEMPLATE_TASK_NAME]: createTemplateTaskRequestModal.reducers.reducer,
  [UPDATE_ASSET_TASK_NAME]: updateAssetTaskRequestModal.reducers.reducer,
  [UPDATE_PROJECT_TASK_NAME]: updateProjectTaskRequestModal.reducers.reducer,
  [UPDATE_TEMPLATE_TASK_NAME]: updateTemplateTaskRequestModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/tasks/reducers/index.js